import { urlConfig } from "../../config/urlConfig";
import { ElasticSearchModel } from "../../types/ElasticSearchModel";
import { postCall } from "../httpService";

const elasticSearchGet = urlConfig.ElasticSearchGet; // Get the ElasticSearchGet endpoint from urlConfig

export const getElasticSearchData = async (params: ElasticSearchModel) => {
    try {
        const response = await postCall(elasticSearchGet,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};
